
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.1 4.8a1.8 1.8 0 00-1.8 1.8v7.2a1.8 1.8 0 001.8 1.8h5.4a1.8 1.8 0 001.8-1.8V8.775a1.8 1.8 0 00-.527-1.273L15.6 5.328a1.8 1.8 0 00-1.273-.527H11.1z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.7 10.2a1.8 1.8 0 011.8-1.8v9h7.2a1.8 1.8 0 01-1.8 1.8H7.5a1.8 1.8 0 01-1.8-1.8v-7.2z","fill":"#fff"}})])
          )
        }
      }
    